export default __webpack_public_path__ + "static/team-victoria-1c151d3ec071269d8cf8f9eb1fc23b38.png";